var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "navigation navigation--default",
      attrs: {
        fixed: "",
        app: "",
        permanent: "",
        "mini-variant": "",
        dark: "",
        floating: "",
        id: "navigation"
      }
    },
    [
      _c("div", { staticClass: "navigation__logo" }, [
        _vm.agencyInfo
          ? _c("img", {
              staticClass: "p-1 navigation--logo",
              attrs: { src: _vm.agencyInfo.logo }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__bg--white __clearfix" }),
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "mt-2", attrs: { "two-line": "", dense: "" } },
        _vm._l(_vm.availableResources, function(nav, index) {
          return _c(
            "v-tooltip",
            {
              key: index,
              attrs: { right: "", color: "secondary", "nudge-left": "20" }
            },
            [
              _c(
                "template",
                { slot: "activator" },
                [
                  _c(
                    "v-list-tile",
                    {
                      staticClass: "__navtivation-item",
                      class: _vm.isActived(nav),
                      attrs: { to: nav.path }
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        {
                          on: {
                            click: function($event) {
                              _vm.coCurrentNav = nav
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.coNavIcon(nav), alt: "" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.getToolTip(nav.key)))])
            ],
            2
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27eab89e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27eab89e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/app/components/the-navigation/template.html
// module id = null
// module chunks = 